import {
configurationLoaded, endpointsInitialized, initEndpoints, loadClientBuildId,
  loadConfiguration, } from 'core/redux/actions/configuration/configurationActions';
import { initApp } from 'core/redux/actions/initApp/initAppActions';
import { disableLegacySearchAction, showAppHeaderEnvAction } from 'core/redux/actions/ui/uiActions';
import { loggedInUser, sessionLoaded } from 'core/redux/actions/user/userActions';
import type { AppThunkDispatch } from 'core/redux/store/configureStore.types';
import { getBrowserTimeZone } from 'core/utilities/dateFormat/dateFormat';
import type { AnyAction,Middleware } from 'redux';

const configurationMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  if (initApp.match(action)) {
    (store.dispatch as AppThunkDispatch)(initEndpoints());
  } else if (endpointsInitialized.match(action)) {
    (store.dispatch as AppThunkDispatch)(loadConfiguration(action.payload.imgRootUrl));
    // (store.dispatch as AppThunkDispatch)(loadClientBuildId());
  } else if (configurationLoaded.match(action)) {
    if (action.payload.configuration.client_bx2_header_environment) {
      (store.dispatch)(showAppHeaderEnvAction());
    }
    if (action.payload.configuration.default_search_uri) {
      (store.dispatch)(disableLegacySearchAction());
    }
    // Set the default document title to be the app name. This will be updated once the page is loaded.
    document.title = action.payload.configuration.app_name;
  } else if (sessionLoaded.match(action)) {
    if (action.payload.appState.appConfiguration) {
      // The configuration is loaded initially via the "init" endpoint
      // Then the "static" call gives us the final configuration along the session
      // That's why we need to dispatch the updated configuration, which will update the redux state
      store.dispatch(
        configurationLoaded(
          'session',
          action.payload.appState.appConfiguration,
          getBrowserTimeZone(),
          action.payload.imgRootUrl,
        ),
      );
    }
  } else if (loggedInUser.match(action)) {
    if (action.payload.appState?.appConfiguration) {
      // The configuration is loaded initially via the "init" endpoint
      // When logging in, the call gives us the final configuration along the session
      // That's why we need to dispatch the updated configuration, which will update the redux state
      store.dispatch(
        configurationLoaded(
          'login',
          action.payload.appState.appConfiguration,
          getBrowserTimeZone(),
          action.payload.imgRootUrl,
        ),
      );
    }
  }

  next(action);
};

export default configurationMiddleware;
